var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "42.08 8 284.92 259.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.90023,9H62.1748C51.643,9,43.075,19.20743,43.075,31.75453V199.28519c0,12.54711,8.568,22.75453,19.09985,22.75453H162.7397v26.20984H118.95889c-4.29165,0-7.803,4.18326-7.803,9.296,0,5.113,3.51136,9.296,7.803,9.296H250.11606c4.29165,0,7.80293-4.18307,7.80293-9.296,0-5.11276-3.51128-9.296-7.80293-9.296H206.33533V222.03972h100.5649C317.43205,222.03972,326,211.8323,326,199.28519V31.75453C326,19.20743,317.43205,9,306.90023,9Zm4.82767,190.28519c0,3.11754-2.21087,5.75127-4.82767,5.75127H62.1748c-2.61688,0-4.82775-2.63373-4.82775-5.75127V31.75453c0-3.11763,2.21087-5.75145,4.82775-5.75145H306.90023c2.6168,0,4.82767,2.63382,4.82767,5.75145Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreen);
export default __webpack_public_path__ + "static/media/icon_screen.623a609b3cdc99fc7e559a52e8689a1a.svg";
export { ForwardRef as ReactComponent };